import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectMessage } from '@store/order/selectors';



const Message = () => {
	const { t } = useTranslation('forms');

	const message = useSelector(selectMessage);

	if (!message || message.length === 0) return (
		<></>	
	)

	return (
		<>
			<div className='order-summary-element'>

				<h2>{t('inputLabels.message')}</h2>

				<div className='summary-property'>
					<p>{message ? message : '-'}</p>
				</div>

			</div>
		</>
	);
};

export default Message;